<template>
    <div class="tabbar-content">
        <div class="tabbar">
            <div v-if="!isShowSport" class="item" :class="{ 'act': actIdx == 2 }" @click.stop="change(2)">
                <span class="tabbar-icon"><AuroraArtIcon name="menu" /></span>
                <div class="item-text">{{ $t("tabbar.menu") }}</div>
            </div>
            <div v-else class="item" @click.stop="toSports"><span class="tabbar-icon"><img class="tabbar-sport-icon" src="@/assets/common/zuqiu.png" alt="" /></span><div class="item-text">{{ $t('sports.title') }}</div></div>
            <div class="item" :class="{ 'act': actIdx == 1 }" @click.stop="change(1)">
                <span class="tabbar-icon"><AuroraArtIcon name="home" /></span>
                <div class="item-text">{{ $t("tabbar.Lobby") }}</div>
            </div>
            <div class="item" :class="{ 'act': actIdx == 3 }" @click.stop="change(3)">
                <span class="tabbar-icon"><AuroraArtIcon name="users" /></span>
                <div class="item-text">{{ $t("tabbar.Affiliate") }}</div>
            </div>
            <div class="item" :class="{ 'act': actIdx == 4 }" @click.stop="change(4)">
                <span class="tabbar-icon"><AuroraArtIcon name="diamond" /></span>
                <div class="item-text">VIP</div>
            </div>
            <div class="item" :class="{ 'act': actIdx == 5 }" @click.stop="change(5)">
                <span class="tabbar-icon"><AuroraArtIcon name="account" /></span>
                <div class="item-text">{{ $t("tabbar.Account") }}</div>
            </div>
        </div>
        <!-- <div v-if="isShowSaveVersion" class="pwa" @click="onShowSaveVersionPopup">
            <div class="iconfont icon-jiahao"></div>
            <div class="txt">{{ $t('downApp.SaveVersionDesktop') }}</div>
            <div class="iconfont icon-s-cuowu-guanbi" @click.stop="onCloseSaveVersion"></div>
        </div> -->
        <pwaIosPopup ref="pwaIosPopup" :isToHome="false"></pwaIosPopup>
        <SaveVersionPopup ref="SaveVersionPopup" :isToHome="false"></SaveVersionPopup>
        <div class="aurora-tabbar-spacer" style="height: 1.24rem"></div>
    </div>
</template>

<script>
import pwaIosPopup from '@/views/downAppPWA/modules/pwaIosPopup'
import SaveVersionPopup from '@/views/downAppPWA/modules/SaveVersionPopup'
import { isPWA, getPlatform } from '@/utils'
import AuroraArtIcon from '@/components/auroraIcon/artIcon.vue'
export default {
    name: 'Tabbar',
    components: { pwaIosPopup, SaveVersionPopup, AuroraArtIcon },
    data() {
        return {
            actIdx: 1,
            isSaveVersionDesktop: true
        }
    },
    computed: {
        isShowSaveVersion() {
            return this.$store.state.system.isSaveVersionDesktop === 1 && this.isSaveVersionDesktop && (!isPWA()) && getPlatform() !== 'android' && getPlatform() !== 'Android'
        },
        isShowSport() {
            if (this.$store.getters.userInfo?.memberType === 'virtually') return false
            const msg = this.$store.state.system.betSportMsg
            return !!(msg && msg.brandId != null && msg.brandId !== '' && msg.gameInfoId != null && msg.gameInfoId !== '')
        }
    },
    created() {
        const path = this.$route.path
        if (path === '/Home') {
            this.actIdx = 1
        }
        if (path === '/Affiliate') {
            this.actIdx = 3
        }
        if (path === '/vip') {
            this.actIdx = 4
        }
        if (path === '/Person') {
            this.actIdx = 5
        }
    },
    watch: {
        $route: {
            handler: function (to, from) {
                const path = this.$route.path
                if (path === '/Home') {
                    this.actIdx = 1
                } else if (path === '/Affiliate') {
                    this.actIdx = 3
                } else if (path === '/vip') {
                    this.actIdx = 4
                } else if (path === '/Person') {
                    this.actIdx = 5
                } else {
                    this.actIdx = -1
                }
            },
            deep: true
        }
    },
    methods: {
        change(idx) {
            if (this.actIdx === idx) return
            if (idx === 1) {
                this.onNavTo({
                    url: '/Home',
                    replace: 1
                })
                this.actIdx = idx
            } else if (idx === 2) {
                this.$store.dispatch('app/toggleSideBar')
            } else if (idx === 3) {
                this.onNavTo({
                    url: '/Affiliate',
                    replace: 1
                })
                this.actIdx = idx
            } else if (idx === 4) {
                this.onTabbarLoginNav({
                    url: '/vip',
                    idx
                })
            } else if (idx === 5) {
                this.onTabbarLoginNav({
                    url: '/Person',
                    idx
                })
            }
        },
        onCloseSaveVersion() {
            this.isSaveVersionDesktop = false
        },
        onShowSaveVersionPopup() {
            this.isSaveVersionDesktop = false
            if (getPlatform() === 'ios') {
                this.$refs.pwaIosPopup.open()
            } else {
                this.$refs.SaveVersionPopup.open()
            }
        },
        onTabbarLoginNav({
            url,
            idx
        }) {
            if (!this.$store.getters.token) {
                this.$store.dispatch('user/changeLoginType', 2)
                this.$store.dispatch('user/setIsShowLoginPopup', true)
                return
            }
            this.onNavTo({
                url,
                replace: 1
            })
            this.actIdx = idx
        },
        toSports() {
            this.onNavTo({
                url: 'Sports'
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.tabbar-sport-icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
$bg-tabbar-color: #ffffff;

html[data-device-nodesktop="1"] {
    .tabbar {
        display: none;
        // max-width: var(--theme-max-width);
    }

    .tabbar-content {
        display: none;
    }
}

html[data-device-nodesktop="0"] {
    .tabbar {
        max-width: 100%;
    }

    .tabbar-content {
        max-width: 100%;
    }
}

.tabbar-content {
    position: relative;

    .pwa {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: .62rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: var(--aurora-surface);
        padding: 0 .26rem;
        color: var(--aurora-accent);
        font-size: .34rem;
        z-index: 101;
        line-height: .34rem;
    }
}

.tabbar {
    position: fixed;
    bottom: 0;
    z-index: 100;
    // position: relative;
    margin: 0 auto;
    height: 1.24rem;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background:
        var(--aurora-soft-gradient);
    border-top: 1px solid var(--aurora-line);
    filter: drop-shadow(0 -4px 10px var(--aurora-shadow-color));
    // box-shadow: 0rpx -6rpx 13rpx 0rpx rgba(202,255,207,.22);

    .item {
        width: 20%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
        overflow: visible;
        position: relative;
        cursor: pointer;
        padding-top: 0.08rem;
        padding-bottom: .2rem;

        ::v-deep .van-icon{
            font-size: .48rem;
            color: var(--aurora-accent);
        }

        .item-text {
            height: .24rem;
            line-height: .24rem;
            width: 100%;
            text-align: center;
            font-size: .24rem;
            color: var(--aurora-accent);
            margin-top: .08rem;
            position: relative;
            z-index: 9;
        }

        &.act {
            ::v-deep .van-icon{
                color: var(--aurora-accent);
            }
            .item-text {
                color: var(--aurora-accent);
            }

            &.center {
                .center-img {
                    .center-inset {
                        border: 1px solid var(--aurora-accent);
                        background: var(--aurora-lilac);
                    }
                }
            }
        }

        &.center {
            position: relative;

            .center-img {
                position: absolute;
                width: 1.2rem;
                height: 1.2rem;
                background: var(--aurora-surface);
                border-radius: 50%;
                top: -12px;
                display: flex;
                align-items: center;
                justify-content: center;
                left: calc(50% - .6rem);

                .center-inset {
                    border: 1px solid var(--aurora-line);
                    border-radius: 50%;
                    width: .95rem;
                    height: .95rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: var(--aurora-soft-gradient);
                    padding-bottom: .05rem;
                }
            }
        }
    }
}
</style>
